import styled from "@emotion/styled";
import { AddAddress } from "components/Replacements/replacementShipToForm.styles.ts";

interface ShipToContainerProps {
	hasBorder?: boolean;
}
export const ShipToContainer = styled.div<ShipToContainerProps>(({ theme, hasBorder = false }) => ({
	backgroundColor: theme.project.colors.backgroundColors.main,
	color: theme.project.colors.fontColors.main,
	"& > div:nth-of-type(2)": {
		...theme.project.typography.caption,
		color: theme.project.colors.fontColors.secondary,
		marginBottom: 16
	},
	...(hasBorder && {
		border: theme.project.borders.presets.outline,
		marginTop: 24,
		padding: 16
	})
}));

export const ShipToAddressContainer = styled.div(({ theme }) => ({
	display: "flex",
	width: "100%",
	alignItems: "center",
	gap: "16px",
	[theme.breakpoints.down("sm")]: {
		flexDirection: "column",
		div: {
			alignSelf: "stretch"
		}
	}
}));

export const ShipToAddressGridItem = styled.div(({ theme }) => ({
	color: theme.palette.error.main,
	flex: 1,
	span: {
		marginTop: "2px"
	}
}));

export const SubtitleText = styled.span(({ theme }) => ({
	...theme.project.typography.subtitle.subtitle2
}));

export const ShipToLabel = styled.div(({ theme }) => ({
	...theme.project.typography.subtitle.subtitle1,
	color: theme.project.colors.fontColors.secondary,
	marginBottom: 16
}));

export const InfoText = styled.div(({ theme }) => ({
	...theme.project.typography.body.body1,
	color: theme.project.colors.fontColors.main
}));

export const NewOrderRequestedDeliveryDate = styled.div(({ theme }) => ({
	marginTop: 16,
	"& .MuiInputBase-input": {
		width: 180,
		height: 8
	},
	"& .MuiFormHelperText-root": {
		width: 190
	},
	"& Button": {
		marginTop: 2,
		...theme.project.typography.body.body1,
		color: theme.project.colors.primaryColors.main,
		textDecoration: "underline",
		"&:hover": {
			textDecoration: "underline",
			cursor: "pointer"
		}
	},
	"& Button:nth-child(2)": {
		margin: "7px 0 0 8px",
		float: "right",
		color: theme.project.colors.fontColors.main
	}
}));

export const WarningContainer = styled.div(({ theme }) => ({
	...theme.project.typography.body.body2,
	alignItem: "center",
	color: theme.project.colors.semanticColors.warning,
	display: "flex",
	flexBasis: "100%",
	fontWeight: 500,
	gap: 8,
	flex: 1,
	svg: {
		height: 20,
		width: 20
	}
}));

export const NewOrderAddAddress = styled(AddAddress)({
	flex: 1,
	margin: 0,
	justifyContent: "flex-end"
});
